/**
 * Phone standard (owner spec 2026-06-11): country code dropdown defaulting to
 * US +1, number formatted as (XXX) XXX-XXXX. Stored as a single string,
 * e.g. "+1 (918) 555-0101".
 */

export const COUNTRY_CODES = [
  { code: '+1', label: 'US +1' },
  { code: '+44', label: 'UK +44' },
  { code: '+52', label: 'MX +52' },
  { code: '+61', label: 'AU +61' },
  { code: '+91', label: 'IN +91' },
] as const;

/** Format a US national number progressively: (XXX) XXX-XXXX */
export function formatUSNumber(input: string): string {
  const d = input.replace(/\D/g, '').slice(0, 10);
  if (d.length === 0) return '';
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

/** Split a stored phone string into { countryCode, national } for editing. */
export function parsePhone(stored: string | null | undefined): {
  countryCode: string;
  national: string;
} {
  const value = (stored ?? '').trim();
  const match = value.match(/^(\+\d{1,3})\s*(.*)$/);
  if (match) return { countryCode: match[1] ?? '+1', national: match[2] ?? '' };
  return { countryCode: '+1', national: value };
}

/** Compose the stored string; empty national → empty string. */
export function composePhone(countryCode: string, national: string): string {
  const trimmed = national.trim();
  if (!trimmed) return '';
  return `${countryCode} ${countryCode === '+1' ? formatUSNumber(trimmed) : trimmed}`;
}
